module.exports = __webpack_public_path__ + "static/media/default~kVeqNTdK.03160ed5.png";